import { Component } from 'react'
import { logException } from '../../logger'
import Button from '../ui/elements/button'
import PropTypes from 'prop-types'

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      error: false,
    }
  }

  static getDerivedStateFromError() {
    return { error: true }
  }

  componentDidCatch(error) {
    logException(error, { level: 'fatal' })
  }

  render() {
    if (this.state.error) {
      return (
        <div className="tw-m-auto tw-max-w-screen-sm">
          <div className="tw-m-auto">
            <div className="tw-text-center tw-m-5 tw-p-8 tw-bg-white tw-max-w-screen-sm">
              <h3 className="tw-custom-reset-heading tw-mb-5 tw-text-2xl tw-custom-uppercase tw-te">
                Sorry... An unexpected error occured
              </h3>
              <p className="tw-custom-reset-heading tw-mb-6">
                Something bad happend, it&rsquo;s not you it&rsquo;s us. You
                could try again or contact our support if the problem persists.
              </p>
              <Button
                size="large"
                onClick={() => this.setState({ error: null })}
                className="tw-max-w-xs tw-mb-0">
                Try Again
              </Button>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.node,
}
